// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { Box, IconButton, InputAdornment, LinearProgress } from "@mui/material";

// NewUser page components
import FormField from "components/FormField";
import MDButton from "components/MDButton";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import axios from "axios";
import { URL_API } from "config";
import { toast } from "react-toastify";

import SearchIcon from '@mui/icons-material/Search';
import { useAuthContext } from "context/AuthContext";

const payload = {
  cep: "",
  number: "",
  complement: "",
  mailing_address: "",
}

export default function CooperatedAddressFifth() {
  const [cooperated, setCooperated] = useState(payload);

  const [street, setStreet] = useState('');
  const [state, setState] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [city, setCity] = useState('');

  const [getCepLoad, setGetCepLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const { uuid } = useParams();
  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        if (uuid) {
          setLoading(true)

          const response = await axios.get(`${URL_API}/cooperated/${uuid}`, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          setStreet(response.data.street);
          setState(response.data.state);
          setNeighborhood(response.data.neighborhood);
          setCity(response.data.city);
          setCooperated(response.data);

          setLoading(false)
        }
      } catch (e) {
        toast.error(e.response)
      }
    })()
    // eslint-disable-next-line
  }, [uuid])

  useEffect(() => {
    (async () => {
      try {
        if (cooperated.cep) {
          const response = await axios.get(`${URL_API}/cep?cep=${cooperated.cep.replace(/[^a-zA-Z0-9]/g, "")}`, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          setStreet(response.data.street);
          setState(response.data.state);
          setNeighborhood(response.data.neighborhood);
          setCity(response.data.city);
        }
      } catch (e) {
        toast.error(e.response.data)
      }
    })()
    // eslint-disable-next-line
  }, [getCepLoad])

  const handleNext = async () => {
    try {
      if (user.profile !== 99) {
        const data = {
          ...cooperated,
          street,
          state,
          neighborhood,
          city,
          step: 5
        }

        if (
          !data.birth_date ||
          !data.cep ||
          !data.number ||
          !data.street ||
          !data.state ||
          !data.neighborhood ||
          !data.city
        ) return toast.warn("Preecha os dados obrigatórios");

        if (uuid) {
          const response = await axios.put(`${URL_API}/cooperated/${uuid}`, data, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${uuid}?step=6`);
        } else {
          const response = await axios.post(`${URL_API}/cooperated`, data, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${response.data.uuid}?step=6`);
        }
      } else {
        navigate(`/admin/colaboradores/atualizar/${uuid}?step=5`);
      }
    } catch (e) {
      toast.error(e.response.data)
    }
  }

  const setInput = (event) => {
    const { name, value } = event.target;

    const newCooperated = {
      ...cooperated,
      [name]: value,
    };

    setCooperated(newCooperated);
  };

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">Endereço</MDTypography>
        <MDTypography variant="button" color="text">
          Informações obrigatórias *
        </MDTypography>
      </MDBox>

      {
        loading ?
          <Box sx={{ width: '100%' }}>
            <LinearProgress sx={{ overflow: 'hidden' }} />
          </Box> :
          <>
            <MDBox mt={1.625}>
              <FormField
                type="text"
                label="CEP"
                name="cep"
                value={cooperated.cep}
                mask="CEP"
                placeholder="CEP"
                onChange={setInput}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" style={{ outline: "none" }}>
                      <IconButton disabled={cooperated.cep && cooperated.cep.length < 9} onClick={() => setGetCepLoad(!getCepLoad)}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <FormField
                type="text"
                label="Rua"
                name="street"
                value={street}
                placeholder="Rua"
                fieldShrink
                onChange={(e) => setStreet(e.target.value)}
                required
              />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Número"
                    name="number"
                    value={cooperated.number}
                    placeholder="Número"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Complementos"
                    name="complement"
                    value={cooperated.complement}
                    placeholder="Complementos"
                    onChange={setInput}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="UF"
                    name="state"
                    value={state}
                    placeholder="UF"
                    fieldShrink
                    onChange={(e) => setState(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Bairro"
                    name="neighborhood"
                    value={neighborhood}
                    placeholder="Bairro"
                    fieldShrink
                    onChange={(e) => setNeighborhood(e.target.value)}
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Cidade"
                    name="city"
                    value={city}
                    placeholder="Cidade"
                    fieldShrink
                    onChange={(e) => setCity(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Endereço de Correspondência"
                    name="mailing_address"
                    value={cooperated.mailing_address}
                    placeholder="Endereço de Correspondência"
                    onChange={setInput}
                  />
                </Grid>
              </Grid>
            </MDBox>

            <MDBox
              mt={2}
              width="100%"
              display="flex"
              justifyContent="space-between"
            >
              <MDButton
                variant="gradient"
                color="light"
                onClick={() => {
                  if (user?.profile !== 99) {
                    navigate(`/admin/colaboradores/atualizar/${uuid}?step=4`)
                  } else {
                    navigate(`/admin/colaboradores/atualizar/${uuid}?step=3`)
                  }
                }}
              >
                voltar
              </MDButton>
              <MDButton
                type="submit"
                variant="gradient"
                color="dark"
                onClick={handleNext}
              >
                próximo
              </MDButton>
            </MDBox>
          </>
      }
    </MDBox>
  );
}


